<template>
  <div class="advanced-search-common">
    <el-form
      v-if="defaultList.length || filterList.length"
      :class="{ 'form-wrapper': useFlexAuto }"
      label-position="top"
      :model="searchForm"
    >
      <el-row class="form-item-wrapper" :gutter="10" :class="{ 'flex-auto': useFlexAuto }">
        <el-col
          v-for="(item, index) in viewList"
          :key="item.searchItemBindingFlag"
          :span="calculateSpan(index, item)"
        >
          <el-form-item :label="item.searchItemDisplayName">
            <!-- input -->
            <template v-if="item.searchItemType === 1">
              <el-input
                v-model="item.searchItemValue"
                class="w100"
                clearable
                :placeholder="$t('common.pleaseEnter')"
                @keyup.enter.native="handleSearch"
              ></el-input>
            </template>
            <!-- input-number -->
            <template v-if="item.searchItemType === 2">
              <el-input-number
                v-model="item.searchItemValue"
                :placeholder="$t('common.pleaseEnter')"
                :min="0"
                @keyup.enter.native="handleSearch"
              ></el-input-number>
            </template>
            <!-- select -->
            <template v-else-if="item.searchItemType === 3">
              <el-select
                v-model="item.searchItemValue"
                class="w100"
                clearable
                collapse-tags
                :placeholder="$t('common.pleaseChoose')"
                :multiple="item.searchItemDataMultiple"
                @change="$event => selectChange($event, item)"
              >
                <template v-for="option in item.searchItemData">
                  <el-option
                    v-show="!option.hidden"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </template>
              </el-select>
            </template>
            <!-- select-page -->
            <template v-else-if="item.searchItemType === 4">
              <el-select
                v-model="item.searchItemValue"
                v-loadmore="$event => selectLoadMore(item, $event)"
                class="w100"
                filterable
                remote
                clearable
                collapse-tags
                :remote-method="$event => selectRemoteMethod($event, item)"
                :placeholder="$t('common.pleaseChoose')"
                :multiple="item.searchItemDataMultiple"
                @visible-change="$event => selectFocus($event, item)"
                @change="$event => selectChange($event, item)"
              >
                <template v-for="option in item.searchItemData">
                  <el-option
                    v-show="!option.hidden"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </template>
              </el-select>
            </template>
            <!-- cascader -->
            <template v-else-if="item.searchItemType === 5">
              <!-- <el-cascader
                clearable
                filterable
                collapse-tags
                :ref="item.searchItemBindingFlag+'cascader'"
                class="w100"
                :show-all-levels="false"
                popperClass="cascader-limit--height"
                v-model="item.searchItemValue"
                :placeholder="$t('common.pleaseChoose')"
                :options="item.searchItemData"
                :props="{ multiple: item.searchItemDataMultiple, checkStrictly: true, expandTrigger: 'hover', emitPath: false }"
              ></el-cascader> -->
              <TreeSelect
                v-model="item.searchItemValue"
                :clearable="true"
                collapse-tags
                :multiple="item.searchItemDataMultiple"
                :placeholder="$t('common.pleaseChoose')"
                :tree-data="item.searchItemData"
                :show-node="false"
                :show-search="true"
                @change="$event => selectChange($event, item)"
              />
            </template>
            <!-- date -->
            <template v-else-if="item.searchItemType === 6">
              <div class="edm-date-picker--width top12">
                <el-date-picker
                  v-model="item.searchItemValue"
                  class="w100"
                  type="date"
                  :placeholder="$t('common.pleaseChoose')"
                ></el-date-picker>
                <svg-icon
                  icon-class="calendar"
                  class="calendar-icon calendar-icon--style top12"
                ></svg-icon>
              </div>
            </template>
            <!-- date-range -->
            <template v-else-if="item.searchItemType === 7">
              <div class="edm-date-picker--width top12">
                <el-date-picker
                  v-model="item.searchItemValue"
                  class="w100"
                  type="daterange"
                  :range-separator="$t('common.searchTo')"
                  :start-placeholder="$t('common.start')"
                  :end-placeholder="$t('common.end')"
                ></el-date-picker>
                <svg-icon
                  icon-class="calendar"
                  class="calendar-icon calendar-icon--style"
                ></svg-icon>
              </div>
            </template>
            <!-- number-range -->
            <template v-if="item.searchItemType === 8">
              <number-range
                v-model="item.searchItemValue"
                :start-placeholder="$t('common.greaterThan')"
                :end-placeholder="$t('common.lessThan')"
              />
            </template>
          </el-form-item>
        </el-col>
        <div v-if="!useFlexAuto" class="search-right">
          <el-button type="primary" class="el-button--84" @click="handleSearch()">
            {{ $t('common.search') }}
          </el-button>
          <el-button type="default" class="el-button--84 self-button-cancel" @click="handleReset()">
            {{ $t('common.reset') }}
          </el-button>
          <el-popover
            v-if="filterList.length"
            v-model="filterPopoverVisible"
            placement="bottom"
            trigger="click"
            :visible-arrow="false"
            style="width: 46px; margin: 0 10px"
            class="self-popover weightText search-more-modal"
          >
            <span slot="reference" class="search-more">
              <span>{{ $t('common.more') }}</span>
              <i
                class="el-icon-arrow-down filter-arrow"
                :class="{ active: filterPopoverVisible }"
              />
            </span>
            <div class="operate-popover" style="width: 395px">
              <div class="operate-popover-title">
                <span class="fnM">{{ $t('common.chooseMore') }}</span>
              </div>
              <div class="overflow-x-y" style="max-height: 300px">
                <el-checkbox-group v-model="searchForm.filter">
                  <el-checkbox
                    v-for="opt in filterList"
                    :key="opt.searchItemBindingFlag"
                    :label="opt.searchItemBindingFlag"
                    :title="opt.searchItemDisplayName"
                    style="width: 100%"
                  >
                    {{ opt.searchItemDisplayName }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="save-condition">
                <el-button
                  type="default"
                  class="el-button--104 self-button-cancel"
                  @click="handleResetFilterItem()"
                >
                  {{ $t('common.reset') }}
                </el-button>
                <el-button type="primary" class="el-button--104" @click="handleConfirmFilterItem()">
                  {{ $t('public.confirm') }}
                </el-button>
              </div>
            </div>
          </el-popover>
          <div
            v-if="filterList.length"
            class="collapse-panel"
            :class="{
              'collapse-panel-disabled': selectFilterList.length === 0 || searchList.length < 6
            }"
            @click="handleCollapse"
          >
            {{ collapseInfo.text }}
            <i :class="collapseInfo.icon"></i>
          </div>
        </div>
      </el-row>
      <!-- 使用useFlexAuto处理一行展示，还是自适应跟随 -->
      <div v-if="useFlexAuto" class="search-right">
        <el-button type="primary" class="el-button--84" @click="handleSearch()">
          {{ $t('common.search') }}
        </el-button>
        <el-button type="default" class="el-button--84 self-button-cancel" @click="handleReset()">
          {{ $t('common.reset') }}
        </el-button>
        <el-popover
          v-if="filterList.length"
          v-model="filterPopoverVisible"
          placement="bottom"
          trigger="click"
          :visible-arrow="false"
          style="width: 46px; margin: 0 10px"
          class="self-popover weightText search-more-modal"
        >
          <span slot="reference" class="search-more">
            <span>{{ $t('common.more') }}</span>
            <i class="el-icon-arrow-down filter-arrow" :class="{ active: filterPopoverVisible }" />
          </span>
          <div class="operate-popover" style="width: 395px">
            <div class="operate-popover-title">
              <span class="fnM">{{ $t('common.chooseMore') }}</span>
            </div>
            <div class="overflow-x-y" style="max-height: 300px">
              <el-checkbox-group v-model="searchForm.filter">
                <el-checkbox
                  v-for="opt in filterList"
                  :key="opt.searchItemBindingFlag"
                  :label="opt.searchItemBindingFlag"
                  :title="opt.searchItemDisplayName"
                  style="width: 100%"
                >
                  {{ opt.searchItemDisplayName }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="save-condition">
              <el-button
                type="default"
                class="el-button--104 self-button-cancel"
                @click="handleResetFilterItem()"
              >
                {{ $t('common.reset') }}
              </el-button>
              <el-button type="primary" class="el-button--104" @click="handleConfirmFilterItem()">
                {{ $t('public.confirm') }}
              </el-button>
            </div>
          </div>
        </el-popover>
        <div
          v-if="filterList.length"
          class="collapse-panel"
          :class="{
            'collapse-panel-disabled': selectFilterList.length === 0 || searchList.length < 6
          }"
          @click="handleCollapse"
        >
          {{ collapseInfo.text }}
          <i :class="collapseInfo.icon"></i>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import NumberRange from "@/components/private/number-range";
import request from "@/utils/request";
export default {
  name: "SearchCurrency",
  components: {
    NumberRange
  },
  props: {
    searchQueryParam: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchForm: {
        filter: []
      },
      filterPopoverVisible: false,
      searchItems: [],
      defaultList: [],
      filterList: [],
      selectFilterList: [],
      valid: true,
      cols: 4,
      // 收起
      collapse: true
    };
  },
  computed: {
    searchConditions() {
      const arr = [...this.selectFilterList, ...this.defaultList].map(o => ({
        searchItemBindingFlag: o.searchItemBindingFlag,
        searchItemValue: o.searchItemValue
      }));
      return JSON.parse(JSON.stringify(arr));
    },
    // 展示的搜索list
    viewList() {
      // 收起的情况下默认返回
      if (this.collapse) {
        return this.defaultList;
      }
      return [...this.defaultList, ...this.selectFilterList];
    },
    // 所有搜索条件
    searchList() {
      return [...this.defaultList, ...this.selectFilterList];
    },
    // 一行内使用自适应
    useFlexAuto() {
      return Array.isArray(this.viewList) && this.viewList.length < 6;
    },
    collapseInfo() {
      if (this.useFlexAuto) {
        return { text: "展开", icon: "el-icon-arrow-down" };
      }

      if (this.collapse) {
        return { text: "展开", icon: "el-icon-arrow-down" };
      }

      return { text: "收起", icon: "el-icon-arrow-up" };
    },
    calculateSpan() {
      const col = 4;
      return (index, item) => {
        const { searchItemType: type } = item;
        // 已满一行
        if (!this.useFlexAuto) {
          // 类型 > 7 的 需要占两个格
          return type >= 7 ? col * 2 : col;
        }

        // <= 一行
        const total = this.viewList.reduce(
          (acc, cur) => (cur.searchItemType >= 7 ? (acc += 2) : (acc += 1)),
          0
        );

        // 处理为5等分的情况下,24不能除尽的只有5
        if (total === 5) {
          return item.searchItemType >= 7 ? 9.6 : 4.8;
        }

        const minCol = Math.floor(24 / total);
        const remainder = 24 % total;
        if (index === this.viewList.length - 1) {
          return minCol * (item.searchItemType >= 7 ? 2 : 1) + remainder;
        } else {
          return minCol * (item.searchItemType >= 7 ? 2 : 1);
        }
      };
    }
  },
  watch: {
    searchConditions: {
      handler(newVal, oldVal) {
        this.autoSearch(newVal, oldVal);
      },
      deep: true
    }
  },
  created() {
    this.getSearchParamsList();
  },
  methods: {
    getSearchParamsList() {
      this.searchQueryParam.forEach(o => {
        const obj = Object.assign({ searchItemValue: undefined }, o);
        const { searchItemType } = obj;
        // 需要去请求接口
        if (searchItemType === 3) {
          // select加载
          if (!obj["searchItemData"] || !obj["searchItemData"].length) {
            obj["searchItemData"] = [];
            if (
              obj.searchItemDataRequestMethod &&
              obj.searchItemDataUrl &&
              obj.searchItemDataService
            ) {
              this.getSelectData(obj);
            }
          } else {
            obj["searchItemData"] = this.formatOption(
              obj["searchItemData"],
              o.searchItemDataLabel,
              o.searchItemDataValue,
              o.searchItemDataChildren
            );
          }
        } else if (searchItemType === 4) {
          // select触底加载更多
          Object.assign(obj, {
            searchItemData: [],
            pageNum: 1,
            pageSize: 10,
            total: 1
          });
        } else if (searchItemType === 5) {
          // tree类型加载
          obj["searchItemData"] = [];
          if (
            obj.searchItemDataRequestMethod &&
            obj.searchItemDataUrl &&
            obj.searchItemDataService
          ) {
            this.getCascadarData(obj);
          }
        }
        if (o.moreFlag) {
          this.filterList.push(obj);
        } else {
          this.defaultList.push(obj);
        }
      });

      this.$set(
        this.searchForm,
        "filter",
        this.filterList.filter(o => !o.hidden).map(o => o.searchItemBindingFlag)
      );
      // 保留原始接口数据
      this.searchItems = this.searchQueryParam;
      // 执行确定
      this.handleConfirmFilterItem();
    },
    // 当每一项值为空时要自动触发搜索
    autoSearch(newVal, oldVal) {
      for (let i = 0; i < newVal.length; i++) {
        const newItem = newVal[i];
        if (
          newItem.searchItemValue === "" ||
          newItem.searchItemValue === undefined ||
          newItem.searchItemValue === null ||
          newItem.searchItemValue.length === 0
        ) {
          // 判断老值是否有值
          const oldItem = oldVal.find(
            v => v.searchItemBindingFlag === newItem.searchItemBindingFlag
          );
          if (
            oldItem &&
            oldItem.searchItemValue !== "" &&
            oldItem.searchItemValue !== undefined &&
            oldItem.searchItemValue !== null &&
            oldItem.searchItemValue.length !== 0
          ) {
            // 执行搜索
            if (this.valid) {
              this.handleSearch();
            } else {
              this.valid = true;
            }
            break;
          }
        }
      }
    },
    getRequest(item, params = {}) {
      const apiQuery = {
        method: item.searchItemDataRequestMethod.toLowerCase()
      };
      // 注意：此处传入对象内多键值对时，需写成{key1:value1},{key2:value2}形式
      const selfParams = item.searchItemDataParams;
      let url = item.searchItemDataService + item.searchItemDataUrl;
      if (item.searchItemDataService !== "/admin") {
        url = `/scim-edm-service${url}`;
      }
      if (selfParams) {
        const paramsArr = selfParams.split(",");
        // 解析
        paramsArr.forEach(o => {
          const rg = new RegExp(`{${o}}`);
          if (rg.test(url)) {
            if (o === "tenantId") {
              url = url.replace(/\{tenantId\}/g, this.$store.getters.tenantId);
            }
          } else if (o === "depId") {
            // console.log("...")
          } else if (/\{.*\}/.test(o)) {
            // 去除{}
            const val = o.substring(1, o.length - 1);
            const arr = val.split(",");
            arr.forEach(t => {
              const oo = t.split(":");
              params[oo[0]] = oo[1];
            });
          }
        });
      }
      if (item.searchItemDataRequestMethod === "get") {
        apiQuery.url = url;
        apiQuery.params = params;
      } else if (item.searchItemDataRequestMethod === "post") {
        apiQuery.url = url;
        if (item.searchItemType === 4) {
          const { page, size, ...arg } = params;
          apiQuery.url = `${apiQuery.url}?page=${page}&size=${size}`;
          apiQuery.data = arg;
        } else {
          apiQuery.data = params;
        }
      }
      return request(apiQuery);
    },
    // 获取下拉框数据
    getSelectData(item) {
      this.getRequest(item).then(res => {
        if (res.success) {
          const { data } = res;
          if (data) {
            if (Array.isArray(res.data)) {
              item["searchItemData"] = this.formatOption(
                res.data,
                item.searchItemDataLabel,
                item.searchItemDataValue,
                item.searchItemDataChildren
              );
            } else {
              const { dictItems = [], records = [] } = res.data;
              if (dictItems && dictItems.length) {
                item["searchItemData"] = this.formatOption(
                  res.data.dictItems,
                  item.searchItemDataLabel,
                  item.searchItemDataValue,
                  item.searchItemDataChildren
                );
              } else if (records && records.length) {
                item["searchItemData"] = this.formatOption(
                  res.data.records,
                  item.searchItemDataLabel,
                  item.searchItemDataValue,
                  item.searchItemDataChildren
                );
              }
            }
          }
        }
      });
    },
    // tree接口
    getCascadarData(item) {
      this.getRequest(item).then(res => {
        if (res.success) {
          let { data } = res;
          if (data) {
            if (!Array.isArray(data)) {
              data = [res.data];
            }
            // 去除根节点
            let child = item.searchItemDataChildren;
            if (!child) {
              child = "children";
            }
            let arr = [];
            data.forEach(o => {
              if (o.parentId === "-1") {
                if (o[child]) {
                  arr = [...arr, ...o[child]];
                }
              } else {
                arr.push(o);
              }
            });
            item["searchItemData"] = this.formatOption(
              arr,
              item.searchItemDataLabel,
              item.searchItemDataValue,
              item.searchItemDataChildren
            );
          }
        }
      });
    },
    // 格式化select或cascadar的option
    formatOption(data, label, key, children) {
      data.forEach(val => {
        const labelArr = label.split(",");
        val.label = labelArr.map(o => val[o]).join("-");
        val.value = val[key];
        if (!children) {
          children = "children";
        }
        if (children !== "children") {
          val["children"] = val[children];
        }
        if (val["children"]) {
          this.formatOption(val["children"], label, key, children);
        }
      });
      return data;
    },
    // 获取select-page的数据
    getSelectPageData(query = "", item) {
      const params = {
        page: item.pageNum,
        size: item.pageSize
      };
      if (item.searchItemDataUrl === "/api/v1/user/page") {
        if (query !== "") {
          params.search = query;
        }
        if (this.$store.getters.tenantId) {
          params.orgId = this.$store.getters.tenantId;
          params.penetrateOrg = true;
        }
      } else {
        params.searchKey = query;
        params.extensionField = query;
      }

      if (
        item.searchItemRelatedComponentName &&
        item.searchItemRelatedUrlParam &&
        item.searchItemRelatedUrlParamValue
      ) {
        params[item.searchItemRelatedUrlParam] = item.searchItemRelatedUrlParamValue;
      }

      this.getRequest(item, params).then(res => {
        if (res.success) {
          const { data } = res;
          if (data) {
            const { records = [], total = 0 } = data;
            if (item.searchItemDataUrl === "/api/v1/user/page") {
              item.searchItemDataLabel = "displayName,username";
            }
            const list = this.formatOption(
              records,
              item.searchItemDataLabel,
              item.searchItemDataValue,
              item.searchItemDataChildren
            );
            item["searchItemData"] = [...item["searchItemData"], ...list];
            item.totalPage = Math.ceil(total / item.pageSize);
          }
        }
      });
    },
    // select加载更多
    selectLoadMore(item) {
      const { pageNum, pageSize, totalPage } = item;
      const data = item["searchItemData"].filter(o => !o.hidden);
      if (data.length === pageNum * pageSize && pageNum < totalPage) {
        item.pageNum++;
        this.getSelectPageData("", item);
      }
    },
    selectRemoteMethod(query, data) {
      data.pageNum = 1;
      data.searchItemData = [];
      this.getSelectPageData(query, data);
    },
    selectFocus(val, data) {
      if (val) {
        if (
          data.searchItemDataRequestMethod &&
          data.searchItemDataUrl &&
          data.searchItemDataService
        ) {
          data.pageNum = 1;
          data.searchItemData = [];
          this.getSelectPageData("", data);
        }
      }
    },
    // 更多重置搜索项
    handleResetFilterItem() {
      this.$set(this.searchForm, "filter", []);
    },
    // 更多确定
    handleConfirmFilterItem() {
      this.filterPopoverVisible = false;
      const arr = [];
      for (let i = 0; i < this.searchForm.filter.length; i++) {
        const key = this.searchForm.filter[i];
        const obj = this.filterList.find(o2 => key === o2.searchItemBindingFlag);
        arr.push(obj);
      }
      this.selectFilterList = arr;
      if (arr.length) {
        this.collapse = false;
        return;
      }

      // 默认收起
      this.collapse = true;
    },
    getSearchParams(search = false) {
      const queryParam = {};
      [...this.selectFilterList, ...this.defaultList].forEach(o => {
        let value = o.searchItemValue;
        if (typeof o.searchItemValue === "string") {
          value = o.searchItemValue.trim();
        }
        if (value !== undefined && value !== null && value !== "") {
          if (search) {
            // 搜索模式下
            if (Array.isArray(value)) {
              // 值为数组
              if (o.searchItemType === 7) {
                value = value.map((val, index) => {
                  if (index === 0) {
                    return `${this.dayjs(val).format("YYYY-MM-DD")} 00:00:00`;
                  } else {
                    return `${this.dayjs(val).format("YYYY-MM-DD")} 23:59:59`;
                  }
                });
              } else if (o.searchItemType === 8) {
                if (value.length === 1) {
                  value[1] = undefined;
                }
                value = value.map((val, index) => {
                  if (index === 0) {
                    return val || 0;
                  } else {
                    return val === undefined || val === null || val === "" ? "MAX_VALUE" : val;
                  }
                });
              }
              if (value.length) {
                queryParam[o.searchItemBindingFlag] = value.toString();
              }
            } else {
              // 值为其他
              if (o.searchItemType === 6) {
                value = `${this.dayjs(value).format("YYYY-MM-DD")} 00:00:00`;
              }
              queryParam[o.searchItemBindingFlag] = value;
            }
          } else {
            // 保存结果下
            // 判断key值所在搜索项的类型；若类型为select-page，保存value值后，需额外保存对应label字段值
            let values = null;
            if (o.searchItemType === 4) {
              // 找到对应值的集合
              let mutiValue = value;
              if (!Array.isArray(mutiValue)) {
                mutiValue = [mutiValue];
              }
              values = o.searchItemData
                .filter(t => mutiValue.includes(t.value))
                .map(it => ({
                  hidden: true,
                  label: it.label,
                  value: it.value
                }));
            }
            if (values && values.length) {
              queryParam[o.searchItemBindingFlag] = { value, values };
            } else {
              queryParam[o.searchItemBindingFlag] = value;
            }
          }
        }
      });
      return queryParam;
    },
    // 搜索
    handleSearch(searchToush = true) {
      const queryParam = this.getSearchParams(true);
      this.$emit("search", queryParam);
    },
    // 重置
    handleReset() {
      this.valid = false;
      [...this.filterList, ...this.defaultList].forEach((o, index, arr) => {
        this.$set(arr[index], "searchItemValue", undefined);
      });
      const queryParam = this.getSearchParams(true);
      this.$emit("reset", queryParam);
    },
    handleCollapse() {
      if (this.selectFilterList.length === 0 || this.searchList.length < 6) {
        return;
      }

      this.collapse = !this.collapse;
    },

    selectChange(e, currentSearchItem) {
      // #begin 1: Try to find out related search item with current search item
      let relatedSearchItem;
      relatedSearchItem = this.defaultList.find(
        item => item.searchItemRelatedComponentName === currentSearchItem.searchItemBindingFlag
      );
      if (!relatedSearchItem) {
        relatedSearchItem = this.selectFilterList.find(
          item => item.searchItemRelatedComponentName === currentSearchItem.searchItemBindingFlag
        );
      }
      // #end 1

      if (relatedSearchItem) {
        // clear related search item content
        relatedSearchItem.searchItemData = [];
        relatedSearchItem.searchItemValue = "";

        // #begin 2: Try find out same name field with related url param from current search item data source
        const currentSearchItemData = currentSearchItem.searchItemData.find(
          item => item[currentSearchItem.searchItemDataValue] === e
        );
        if (currentSearchItemData !== undefined) {
          // Get same name field
          const relatedParamValue =
            currentSearchItemData[relatedSearchItem.searchItemRelatedUrlParam];
          if (relatedParamValue !== undefined) {
            relatedSearchItem.searchItemRelatedUrlParamValue = relatedParamValue;
            return;
          }
        }
        // #end 2

        // Use event value as param value when not find a same name field
        relatedSearchItem.searchItemRelatedUrlParamValue = e;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .number-range{
    position: relative;
    width: 100%;
    padding: 1px;
    padding-right: 50px;
    border: 1px solid #d4d9e2;

    .number-range-input{
      display: flex;
      height: 28px;
      line-height: 28px;
      flex-direction: row;
      align-items: center;
    }

    .range-min,
    .range-max{
      flex: 1;

      .el-input__inner{
        height: 100%;
        line-height: 28px;
        border-width: 0;
      }
    }

    .range-to{
      margin: 0 10px;
    }

    .number-range-close{
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      display: none;
      width: 50px;
      padding-right: 5px;
      color: #c6ccd7;
      text-align: right;
      cursor: pointer;

      &:hover{
        color: #9ea5b2;
      }
    }

    &:hover{
      border-color: #00b259;

      .number-range-close{
        display: block;
      }
    }

    &.is-focus{
      border-color: #00b259;
      border-width: 1px;
      box-shadow: inset 0 0 0 1px #00b259;

       .number-range-close{
        display: block;
      }
    }

  }
.advanced-search-common {
  .search-layout {
    display: flex;
    align-items: flex-end;
  }

  .search-right {
    display: flex;
    align-items: center;
    float: left;
    margin-top: 20px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;
    white-space: nowrap;

    .el-button {
      // padding-top: 12px;
      // padding-bottom: 12px;
    }

    .search-more {
      display: inline-block;
      white-space: nowrap;
      cursor: pointer;

      &:hover {
        color: #00b259;
      }

      &::after {
        display: inline-block;
        padding: 0 6px;
        color: #21252e;
        cursor: default;
        content: '|';
      }
    }

    .save-filter {
      display: inline-block;
      margin-left: 6px;
      cursor: pointer;

      &:hover {
        color: #00b259;
      }

      &::after {
        display: inline-block;
        padding: 0 6px;
        color: #21252e;
        cursor: default;
        content: '|';
      }
    }
  }

  .search-result {
    margin: 8px 0 10px;
  }

  .save-filter-item {
    display: inline-block;
    height: 24px;
    padding: 0 12px;
    margin-top: 6px;
    margin-right: 8px;
    margin-bottom: 8px;
    line-height: 22px;
    cursor: pointer;
    background: #eaedf3;
    border: 1px solid #d4d9e2;
    border-radius: 25px;
    box-sizing: border-box;

    &.active {
      color: #00b259;
      background: transparent;
      border: 1px solid #00b259;
    }
  }
}

.operate-popover {
  padding: 10px;

  .operate-popover-title {
    margin-bottom: 6px;
    line-height: 34px;
    border-bottom: 1px solid #f2f2f2;
  }

  .el-checkbox {
    margin: 0;
    line-height: 34px;

    ::v-deep .el-checkbox__label {
      display: inline-block;
      width: calc(100% - 14px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transform: translateY(4px);
    }
  }

  .save-condition {
    padding-top: 8px;
    text-align: right;
  }
}

.el-button--84 {
  width: 84px;
}

.el-button--104 {
  width: 104px;
}

.form-wrapper {
  display: flex;
  align-items: flex-end;

  .flex-auto {
    flex: 1;
  }
}

.form-item-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;

  .el-form-item {
    margin-bottom: 5px;
  }
}

.collapse-panel {
  cursor: pointer;
  display: inline-block;
  padding-right: 4px;
  background-color: #fff;

  &:hover {
    color: #00b259;
  }
}

.collapse-panel-disabled {
  cursor: not-allowed;

  &:hover {
    color: #21252e;
  }
}
.search-left {
  flex: 1;
  margin-right: 20px;

  .el-form-item {
    margin-bottom: 5px;
  }
}
.el-col.el-col-4\.8 {
  width: 20%;
}
.el-col.el-col-9\.6 {
  width: 40%;
}
.edm-date-picker--width{
  position: relative;
    width: 100%;
    .calendar-icon--style{
      position: absolute;
      top: 8px;
      right: 8px;
      width: 16px !important;
      height: 16px !important;
      color: #c6ccd7;
      text-align: center;
      pointer-events: none;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
    }
}
</style>
